import type { HistoricalMessage } from "./history";

function record(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
}
function rows(value: unknown): Record<string, unknown>[] { return Array.isArray(value) ? value.map(record) : []; }

// Original questions are retained text, never live choices or approvals. There
// are no event callbacks, remote images, markup execution or permission reads.
export function HistoricalMessages({ messages }: { messages: HistoricalMessage[] }) {
  return <>{messages.map((message) => {
    const saved = message.original, request = record(saved.inputRequest), response = record(saved.inputRequestResponse);
    return <div key={message.id} data-historical-message={message.id}
      className={`max-w-[90%] rounded-2xl px-4 py-3 text-sm leading-6 ${message.role === "user" ? "ml-auto bg-[#dceffc]" : "mr-auto bg-[#ecece7]"}`}>
      <p className="whitespace-pre-wrap break-words">{message.text}</p>
      {typeof request.question === "string" && request.question !== message.text ? <p className="mt-2 whitespace-pre-wrap break-words">{request.question}</p> : null}
      <SavedChoices choices={request.choices} />
      {rows(request.questions).map((question, index) => <div key={index} className="mt-2">
        {typeof question.question === "string" ? <p className="font-medium whitespace-pre-wrap break-words">{question.question}</p> : null}
        <SavedChoices choices={question.choices} />
      </div>)}
      {rows(response.answers).map((answer, index) => answer.skipped === true || typeof answer.answer === "string"
        ? <p key={index} className="mt-2 whitespace-pre-wrap break-words">{answer.skipped === true ? "Skipped" : answer.answer as string}</p> : null)}
      {typeof saved.reaction === "string" ? <p className="mt-2 text-xs" aria-label={`Reacted ${saved.reaction}`}>{saved.reaction}</p> : null}
    </div>;
  })}</>;
}

function SavedChoices({ choices }: { choices: unknown }) {
  const labels = rows(choices).flatMap((choice) => typeof choice.label === "string" ? [choice.label] : []);
  return labels.length ? <ul className="mt-2 text-[#52606e]">{labels.map((label, index) => <li key={index} className="whitespace-pre-wrap break-words">{label}</li>)}</ul> : null;
}
